<script lang="ts">
	import type { OrderLine } from '$lib/types/Order/order';
	import OrderLineItemCard from '../Card/OrderLineItemCard.svelte';

	export let orderLineItems: Array<OrderLine>;
</script>

<div class="flex flex-col mt-8 space-y-7 divide-y-[1px] divide-solid divide-dark-quaternary">
	{#each orderLineItems as orderLineItem, index}
		<OrderLineItemCard additionalClass={index !== 0 ? 'pt-8' : ''} {orderLineItem} />
	{/each}
</div>
